<template>

    <div style="overflow-y: hidden">
        <v-row
            v-ripple
            :class="selected ? 'selected' : 'hover-item'"
            align="center"
            class="pl-2 hide-parent flex-wrap: nowrap"
            no-gutters
            style="overflow-y: hidden; overflow-x: hidden; cursor: pointer"
        >
<!--Loading And Check Box-->
            <v-col
                v-if="loading || showCheckBoxes"
                class="flex-shrink-1 flex-grow-0 pr-2"
            >
                <v-progress-circular
                    v-if="loading"
                    :size="20"
                    :width="2"
                    color="grey"
                    indeterminate
                />
                <template v-else>
                    <v-icon
                        v-if="showCheckBoxes"
                        :color="selected ? 'primary' : 'grey'"
                        class="pa-0 ma-0"
                        @click="$emit('selection', !selected)"
                    >
                        {{selected ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}
                    </v-icon>
                </template>
            </v-col>
<!--Main Text-->
            <v-col
                :class="subLine ? 'py-0' : 'py-1'"
                class="pr-2 py-1"
                style="overflow-y: auto; overflow-x: hidden"
                @click="$emit(showCheckBoxes ? 'select' : 'selection', !selected)"
            >
                <div
                    v-if="headerLine || hasHeadline"
                    class="text-truncate"
                    style="line-height: 1"
                >

                    <template v-if="!hasHeadline">
                        {{headerLine || null}}
                    </template>

                    <slot name="headline"/>

                </div>




                <div v-if="subLine || hasSubLine" class="text-truncate caption grey--text" style="line-height: 1">
                    <template v-if="!hasSubLine">
                        {{Array.isArray(subLine) ? subLine.join(', ') : subLine}}
                    </template>

                    <slot name="subLine"/>
                </div>
            </v-col>
<!--Action Buttons-->
            <template
                v-if="actionButtons"
            >
                <template v-for="(btn, i) in actionButtons">
                    <v-col
                        v-if="btn.hoverItem !== 'selectedOnly' ? true : selected"
                        :key="i"
                        :class="btn.hoverItem === true || btn.hoverItem === 'selectedOnly' ? 'hide-child' : null"
                        class="pr-2 flex-grow-0 flex-shrink-1"
                    >
                        <v-btn
                            :color="typeof btn.color == 'string' ? btn.color : btn.color(item)"
                            class="pa-0 ma-0"
                            icon
                            small
                            text
                            @click="btn.cb(item)"
                        >
                            <v-icon>{{typeof btn.icon == 'string' ? btn.icon : btn.icon(item)}}</v-icon>
                        </v-btn>
                    </v-col>
                </template>
            </template>
            <slot name="action"></slot>
        </v-row>
        <v-divider></v-divider>
    </div>

</template>

<script>
    import {blankString} from "@/core/codeFunctions"

    export default {
        props: {
            line1: String,
            line2: String,
            actionButtons: Array,
            showCB: Boolean,
            item: Object,
            loading: Boolean,
            selected: Boolean,
            showCheckBoxes: Boolean,
        },
        computed: {
            headerLine() {
                return blankString(this.item[this.line1]) ? null : this.item[this.line1];
            },
            subLine() {
                return blankString(this.item[this.line2]) ? null : this.item[this.line2];
            },
            hasHeadline() {
                return !!this.$slots.headline
            },
            hasSubLine() {
                return !!this.$slots.subLine
            },
            hasAction() {
                return !!this.$slots.action
            },
        }
    }
</script>

<style scoped>

</style>
